import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { Toaster } from 'sonner';
import { router } from './router';
import { useTheme } from './lib/theme';
import './styles/app.css';
import { setEngineTranslator } from '@lumo/engine/i18n';
import { tr } from './i18n';

// Подписи, которые рисует движок (статусы карточек, «Без названия» и т.п.), — на языке интерфейса.
setEngineTranslator(tr);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
  },
});

function ThemedToaster() {
  const theme = useTheme((s) => s.resolved);
  return (
    <Toaster
      theme={theme}
      position="bottom-center"
      toastOptions={{ className: '!rounded-panel !font-sans !shadow-float' }}
    />
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <ThemedToaster />
    </QueryClientProvider>
  </StrictMode>,
);
